export default {
      id: "ic_tribun_coupon_entry_edit-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun_coupon_entry_edit-usage",
      toString: function () {
        return this.url;
      }
    }